export type Theme = "night" | "day";

export function theme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "day" ? "day" : "night";
}

export function setTheme(t: Theme) {
  if (t === "day") document.documentElement.setAttribute("data-theme", "day");
  else document.documentElement.removeAttribute("data-theme");
  try {
    localStorage.setItem("melo.theme", t);
  } catch {
    // Private windows may refuse storage; the theme still applies for this visit.
  }
}
